import React, { useEffect, useState } from 'react';
import { mediaUrl } from '../utils/media';

const pressPhotos = [
  'Photo from Anand Mashatte(44).jpg',
  'Photo from Anand Mashatte(27).jpg',
  'IMG-20260708-WA0004.jpg',
  'IMG-20260708-WA0005.jpg',
  'IMG-20260620-WA0045.jpg',
  'IMG-20260620-WA0000.jpg',
  '14.PNG',
];

const PressGallery: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  useEffect(() => {
    if (activeIndex === null) {
      return undefined;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setActiveIndex(null);
      }
      if (event.key === 'ArrowRight') {
        setActiveIndex((index) => (index === null ? index : (index + 1) % pressPhotos.length));
      }
      if (event.key === 'ArrowLeft') {
        setActiveIndex((index) => (index === null ? index : (index - 1 + pressPhotos.length) % pressPhotos.length));
      }
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [activeIndex]);

  const activePhoto = activeIndex === null ? null : pressPhotos[activeIndex];

  return (
    <>
      <div className="row g-4 press-grid">
        {pressPhotos.map((file, index) => (
          <div className="col-12 col-md-6 col-lg-4" key={file}>
            <button
              type="button"
              className="press-thumb"
              onClick={() => setActiveIndex(index)}
              aria-label={`Preview newspaper photo ${index + 1}`}
            >
              <img src={`${mediaUrl(file)}?tr=w-800`} alt="" />
            </button>
          </div>
        ))}
      </div>

      {activePhoto && activeIndex !== null && (
        <div className="events-lightbox" role="dialog" aria-modal="true" aria-label="Newspaper preview" onClick={() => setActiveIndex(null)}>
          <div className="events-lightbox-content" onClick={(event) => event.stopPropagation()}>
            <div className="events-lightbox-toolbar">
              <small className="text-white-50">
                {activeIndex + 1} / {pressPhotos.length}
              </small>
              <button type="button" className="events-lightbox-close" aria-label="Close preview" onClick={() => setActiveIndex(null)}>
                <i className="fa fa-times"></i>
              </button>
            </div>
            <div className="events-lightbox-stage">
              <button
                type="button"
                className="events-lightbox-nav events-lightbox-prev"
                aria-label="Previous"
                onClick={() => setActiveIndex((activeIndex - 1 + pressPhotos.length) % pressPhotos.length)}
              >
                <i className="fa fa-chevron-left"></i>
              </button>
              <button
                type="button"
                className="events-lightbox-nav events-lightbox-next"
                aria-label="Next"
                onClick={() => setActiveIndex((activeIndex + 1) % pressPhotos.length)}
              >
                <i className="fa fa-chevron-right"></i>
              </button>
              <img className="events-lightbox-media" src={`${mediaUrl(activePhoto)}?tr=w-1600`} alt="Newspaper coverage" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PressGallery;
